import { render, staticRenderFns } from "./PageShellUserManagement.vue?vue&type=template&id=c67f60ea"
import script from "./PageShellUserManagement.vue?vue&type=script&lang=js"
export * from "./PageShellUserManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports